import React from "react";
import { ReCaptchaProvider } from "@wss/re-captcha";
import LeftAsideLayout from "../../common/Layout/LeftAsideLayout";
import Store, { Provider } from "~/common/Store";
import SupportSidebar from "./SupportSidebar";
import SupportCategory from "./Models/SupportCategory";
import SupportSidebarSticky from "./SupportSidebarSticky";
import Search from "./Search/Search";
import SupportIcons from "./SupportIcons";
import SupportAsk from "./GetInTouch/SupportAsk";
import SupportFAQ from "./Models/SupportFAQ";
import QuestionsWrapper from "./Questions/QuestionsWrapper";
import { ContactStep } from "./GetInTouch/Step";
import { DefaultFormData } from "./GetInTouch/NextSteps/ContactCustomerService/GeneralContactForm";

export interface FormProps {
  contactId: number;
  initialStep: ContactStep;
  displayHeader: string;
  categories: SupportCategory[];
  frequentlyAskedQuestions: SupportFAQ[];
  recaptchaAction: string;
  searchText: string;
}

export type Props = FormProps;

export default function SupportPage({
  contactId,
  initialStep,
  displayHeader,
  categories,
  frequentlyAskedQuestions,
  recaptchaAction,
  searchText,
}: Props) {
  const { fullName, emailAddress, billingPhoneNumber } = Store.getState().user;

  const defaultFormData: DefaultFormData = {
    contactId,
    name: fullName ?? "",
    email: emailAddress ?? "",
    phone: billingPhoneNumber ?? "",
  };

  return (
    <Provider store={Store}>
      <ReCaptchaProvider action={recaptchaAction}>
        <LeftAsideLayout
          sidebar={
            <div>
              <SupportAsk
                contactId={contactId}
                initialStep={initialStep}
                defaultFormData={defaultFormData}
                classNames="float-none lt:hidden"
              />
              <SupportSidebar />
            </div>
          }
          sidebarSticky={<SupportSidebarSticky {...{ categories }} />}
        >
          <>
            <SupportAsk
              contactId={contactId}
              initialStep={initialStep}
              defaultFormData={defaultFormData}
              classNames="lt:block hidden"
            />
            <Search {...{ displayHeader, searchText }} />
            <SupportIcons {...{ categories }} />
            <QuestionsWrapper
              questionList={frequentlyAskedQuestions}
              showCategoryNames
            />
          </>
        </LeftAsideLayout>
      </ReCaptchaProvider>
    </Provider>
  );
}
